export const REPORTS_UPDATE_STORY_ID = 'REPORTS/UPDATE_STORY_ID';
export const REPORTS_UPDATE_CAMPAIGNS = 'REPORTS/UPDATE_CAMPAIGNS';

export function reportsUpdateStoryId({ storyId }) {
  return {
    type: REPORTS_UPDATE_STORY_ID,
    params: { storyId },
  };
}
